import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import parse from "html-react-parser";
import { apolloWpClient } from "../../lib/graphql";
import {
  GetAllPostsQuery,
  GetPostBySlugQuery,
} from "../../lib/graphql/codegen/generated-client-wp";
import {
  GetPostBySlug,
  GetAllPosts,
} from "../../lib/graphql/queries/wordpress/posts.graphql";
import { PageContainer } from "../../components/Layout/PageContainer";
import FooterBar from "../../components/Blog/FooterBar";
import TitleBar from "../../components/Blog/Titlebar";
import Breadscrumb from "../../components/Blog/Breadscrumb";
import Seo from "../../components/others/Seo";

const Article = ({ post }: { post: GetPostBySlugQuery["post"] }) => {
  const featuredImage = post?.featuredImage?.node;
  return (
    <PageContainer>
      <Seo
        title={post?.title ?? undefined}
        ogImage={post?.featuredImage?.node.sourceUrl ?? undefined}
        description={post?.excerpt ?? undefined}
      />
      <TitleBar title={post?.title || ""} />
      <Breadscrumb
        paths={[
          { title: "Blog", url: "/blog" },
          { title: post?.title ?? "/", url: `/blog/${post?.slug}` },
        ]}
      />
      <Stack maxWidth="lg">
        {featuredImage?.sourceUrl && (
          <Box sx={{ position: "relative", height: 400 }}>
            <Image
              src={featuredImage?.sourceUrl}
              alt={featuredImage?.altText ?? ""}
              fill
              priority
              style={{ objectFit: "cover", objectPosition: "center" }}
            />
          </Box>
        )}
        <Box
          display="flex"
          flexDirection="column"
          sx={{ px: { xs: 2, lg: 0 } }}
        >
          {parse(post?.content ?? "")}
        </Box>
      </Stack>
      <FooterBar />
    </PageContainer>
  );
};

export const getStaticProps = async ({
  params,
}: {
  params: { slug: string };
}) => {
  const post = await apolloWpClient.query<GetPostBySlugQuery>({
    query: GetPostBySlug,
    variables: { slug: params.slug },
  });
  return {
    props: {
      post: post.data.post,
    },
  };
};

// This function gets called at build time
export async function getStaticPaths() {
  const posts = await apolloWpClient.query<GetAllPostsQuery>({
    query: GetAllPosts,
  });

  const paths = posts.data.posts?.edges.map((edge) => ({
    params: { slug: edge.node.slug },
  }));

  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
}

export default Article;
